import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { msalInstance } from "../AppAuth";
import { API_SCOPES } from "../authConfig";

export const getPhoto = async (userId, accessToken) => {
  const url = "https://graph.microsoft.com/v1.0/" + userId + "/photo/$value";

  return fetch(url, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + accessToken.accessToken,
      "Content-Type": "application/json",
    },
  });
};

export const getToken = async () => {
  const account =
    msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];

  if (!account) {
    throw Error(
      "No active account! Verify a user has been signed in and setActiveAccount has been called."
    );
  }

  msalInstance.setActiveAccount(account);

  const userRequest = {
    scopes: API_SCOPES,
    account: account,
  };

  let response;
  try {
    response = await msalInstance.acquireTokenSilent(userRequest);
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      response = await msalInstance.acquireTokenPopup(userRequest);
    } else {
      throw error;
    }
  }

  return response.accessToken;
};

//Token that lets you fetch groups and user info
export const getToken2 = async () => {
  const account =
    msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];

  if (!account) {
    throw Error(
      "No active account! Verify a user has been signed in and setActiveAccount has been called."
    );
  }

  msalInstance.setActiveAccount(account);

  const userRequest = {
    scopes: ["GroupMember.Read.All", "Group.Read.All", "User.Read.All"],
    account: account,
  };

  try {
    const response = await msalInstance.acquireTokenSilent(userRequest);
    return response.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      const interactiveResponse = await msalInstance.acquireTokenPopup(
        userRequest
      );
      return interactiveResponse.accessToken;
    }

    console.error(error);
    throw new Error("Failed to acquire token");
  }
};
